import { useMutation } from "@tanstack/react-query";
import axios from "axios";
import { notification } from "antd";
import { useNavigate } from "react-router-dom";
import { jwtDecode } from "jwt-decode";

const BASE_URL = process.env.REACT_APP_BACKEND_URL;

export const loginUser = async ({ email, password }) => {
  const response = await axios.post(
    `${BASE_URL}/auth/login`,
    { email, password },
    {
      headers: { "Content-Type": "application/json" },
    }
  );
  return response.data;
};

export const useLoginMutation = () => {
  const navigate = useNavigate();

  return useMutation({
    mutationFn: loginUser,

    onSuccess: (data) => {
      console.log("LOGIN RESPONSE:", data);

      let token = data.token;
      let role = data?.savedInDB?.role;

      // Validation
      if (!token) {
        notification.error({ message: "Token missing in response!" });
        return;
      }

      localStorage.setItem("token", token);
      localStorage.setItem("role", role);
      localStorage.setItem("isLogin", "true");

      // ⭐ Save User ID (NEW)
      if (data.userId) {
        localStorage.setItem("userId", data.userId);
      }

      // ⭐ Save initials (NEW)
      if (data.initials) {
        localStorage.setItem("initials", data.initials);
      }

      // Save extra user DB data
      if (data.savedInDB) {
        localStorage.setItem("firstName", data.savedInDB.firstName );
        localStorage.setItem("lastName", data.savedInDB.lastName );
        localStorage.setItem("gender", data.savedInDB.gender );
      }

      // Decode expiry
      try {
        const decoded = jwtDecode(token);

        if (decoded.exp) {
          const expiryTime = decoded.exp * 1000 - Date.now();

          setTimeout(() => {
            localStorage.clear();
            notification.warning({
              message: "Session expired. Please log in again.",
            });
            navigate("/login");
          }, expiryTime);
        }
      } catch (error) {
        console.error("Token decode failed:", error);
      }

      // Notification
      notification.success({
        message: role === "admin" ? "Admin Login Successful" : "Login Successful",
      });

      // Redirect
      if (role === "admin") {
        navigate("/admin-dashboard");
      } else if (role === "warehouse") {
        navigate("/warehouse-dashboard");
      } else {
        navigate("/dashboard");
      }
    },

    onError: (error) => {
      notification.error({
        message: "Invalid credentials",
        description: error?.response?.data?.message || "Login failed",
      });
    },
  });
};
